import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const vat = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/vat/{profile}/vat',
    app: 'vat',
    pk: 'code'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'vat', model: 'vat' }
    ),
    { }
  )
)()

export { vat, TYPES }
